{
  "journalAudit.action.organisation.payment_method_added": "Payment method added",
  "journalAudit.action.organisation.payment_method_defaulted": "Default payment method changed",
  "journalAudit.action.organisation.payment_method_removed": "Payment method removed",
  "journalAudit.action.organisation.payment_method_session_opened": "Payment method entry opened",
  "journalAudit.action.organisation.payment_retried": "Payment retried",
  "journalAudit.action.organisation.plan_change_cancelled": "Plan change cancelled",
  "journalAudit.action.organisation.plan_change_requested": "Plan change requested",
  "journalAudit.action.organisation.plan_changed": "Plan changed",
  "journalAudit.action.organisation.subscription_cancellation_withdrawn": "Cancellation withdrawn",
  "journalAudit.action.organisation.subscription_cancelled": "Cancellation scheduled",
  "journalAudit.action.organisation.usage_alerts_updated": "Usage alerts updated",
  "journalAudit.action.organisation.usage_exported": "Usage statement exported",
  "v9.abonnement.acces.acces_restreint_la_facturation_reste_ouverte": "Restricted access: billing stays open.",
  "v9.abonnement.acces.masque": "Full access.",
  "v9.abonnement.acces.suspendu_pour_impaye_seule_la_facturation_reste_ouverte": "Suspended for non-payment: only billing stays open.",
  "v9.abonnement.acces.vide": "No access restriction.",
  "v9.abonnement.action.organisation.payment_retried": "Payment retried",
  "v9.abonnement.action.organisation.plan_change_cancelled": "Change cancelled",
  "v9.abonnement.action.organisation.plan_change_requested": "Change requested",
  "v9.abonnement.action.organisation.plan_changed": "Plan changed",
  "v9.abonnement.action.organisation.subscription_cancellation_withdrawn": "Cancellation withdrawn",
  "v9.abonnement.action.organisation.subscription_cancelled": "Cancellation scheduled",
  "v9.abonnement.ajout.aucune_donnee": "No payment data is entered or kept in DoIt.",
  "v9.abonnement.ajout.composant_pret": "The provider component is ready: enter your method there.",
  "v9.abonnement.ajout.deja_enregistre": "Method already saved.",
  "v9.abonnement.ajout.enregistrer": "Save the method",
  "v9.abonnement.ajout.mobile_money": "Mobile money: the operator is chosen in the component; instalments are paid by link.",
  "v9.abonnement.ajout.mobile_money_autre": "Mobile money: choose this type to pay through your operator; instalments are paid by link.",
  "v9.abonnement.ajout.nature": "Method type",
  "v9.abonnement.ajout.par_defaut": "Set as default method",
  "v9.abonnement.ajout.reference": "Entry reference",
  "v9.abonnement.ajout.succes": "Method saved.",
  "v9.abonnement.annonce.texte": "Price change announced: {{prix}} from {{le}}; cancel before {{avant}} to avoid it.",
  "v9.abonnement.annonce.vide": "No price change announced.",
  "v9.abonnement.annuler": "Cancel",
  "v9.abonnement.aucun_moyen": "No payment method: add one first.",
  "v9.abonnement.avis.choix.100": "At 100%",
  "v9.abonnement.avis.choix.80": "At 80%",
  "v9.abonnement.avis.choix.aucun": "No alert",
  "v9.abonnement.avis.choix.personnalise": "Custom",
  "v9.abonnement.avis.enregistre": "Alerts saved.",
  "v9.abonnement.avis.enregistrer": "Save alerts",
  "v9.abonnement.avis.liste": "Recipients (identifiers, comma-separated)",
  "v9.abonnement.avis.personnalises": "Custom thresholds (1 to 100, comma-separated)",
  "v9.abonnement.avis.proprietaire_et_administrateurs": "Owner and administrators",
  "v9.abonnement.avis.rien_a_enregistrer": "Nothing to save.",
  "v9.abonnement.avis.seuils": "Thresholds",
  "v9.abonnement.avis.seuils_invalides": "Invalid thresholds: 1 to 100.",
  "v9.abonnement.avis.titre": "Usage alerts",
  "v9.abonnement.ce_qui_depasse": "What exceeds the target plan",
  "v9.abonnement.changement.annule": "Change cancelled.",
  "v9.abonnement.changement.lien.autre": "Track the change in progress",
  "v9.abonnement.changement.lien.descente": "Track: downgrade",
  "v9.abonnement.changement.lien.migration": "Track: subscriber migration",
  "v9.abonnement.changement.lien.montee": "Track: upgrade",
  "v9.abonnement.changement.lien.periodicite": "Track: billing period change",
  "v9.abonnement.changement.lien.resiliation": "Track: cancellation",
  "v9.abonnement.changement.lien.souscription_devis": "Track: quote subscription",
  "v9.abonnement.changement.lien.souscription_essai": "Track: trial plan subscription",
  "v9.abonnement.changement.reessai_envoye": "Retry sent.",
  "v9.abonnement.changement.resiliation_annulee": "Cancellation withdrawn.",
  "v9.abonnement.changer.comparer": "Compare plans",
  "v9.abonnement.changer.sans_palier": "First choose a plan in the plan comparison.",
  "v9.abonnement.code.AUCUNE_RESILIATION_PROGRAMMEE": "No cancellation is scheduled.",
  "v9.abonnement.code.CHANGEMENT_DEJA_EN_COURS": "A subscription change is already in progress.",
  "v9.abonnement.code.CHANGEMENT_NON_ANNULABLE": "This change can no longer be cancelled.",
  "v9.abonnement.code.CONFIRMATION_IDENTITE_ECHOUEE": "The secret does not match.",
  "v9.abonnement.code.CONFIRMATION_IDENTITE_REQUISE": "Confirm your identity before this action.",
  "v9.abonnement.code.CONTEXTE_INCOMPLET": "No organisation in the session.",
  "v9.abonnement.code.DEJA_AU_PALIER_GRATUIT": "The organisation is already on the free plan.",
  "v9.abonnement.code.DESCENTE_BLOQUEE_PAR_L_USAGE": "Your usage exceeds the target plan quotas: reduce it before downgrading.",
  "v9.abonnement.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v9.abonnement.code.IDEMPOTENCY_CONFLICT": "This request was already sent with other values.",
  "v9.abonnement.code.MOYEN_DE_PAIEMENT_REQUIS": "Add a payment method before upgrading.",
  "v9.abonnement.code.MOYEN_DE_PAIEMENT_SEUL_REQUIS": "This is your only payment method and your subscription requires a debit.",
  "v9.abonnement.code.PAIEMENT_REFUSE": "The provider declined the payment: nothing was changed.",
  "v9.abonnement.code.PLATFORM_ADMIN_REQUIRED": "Reserved for platform administration.",
  "v9.abonnement.code.PRESTATAIRE_INDISPONIBLE": "The payment provider is unavailable: try again later.",
  "v9.abonnement.code.PROPRIETAIRE_SEUL": "Reserved for the organisation owner.",
  "v9.abonnement.code.RESILIATION_DEJA_PROGRAMMEE": "A cancellation is already scheduled.",
  "v9.abonnement.code.RESOURCE_UNAVAILABLE": "Not found.",
  "v9.abonnement.code.VALIDATION_ERROR": "Invalid input.",
  "v9.abonnement.code.VERSION_CONFLICT": "Changed in the meantime: reload before retrying.",
  "v9.abonnement.confirmer_changement": "Confirm the change",
  "v9.abonnement.credit.origine.avoir": "credit note",
  "v9.abonnement.credit.origine.geste_commercial": "goodwill gesture",
  "v9.abonnement.credit.texte": "Available credit: {{montant}} ({{origine}}).",
  "v9.abonnement.credit.vide": "No credit available.",
  "v9.abonnement.ecran.dialogue-ajouter-moyen-paiement": "Add a payment method",
  "v9.abonnement.ecran.dialogue-changer-palier": "Force an organisation’s plan",
  "v9.abonnement.ecran.dialogue-changer-palier-organisation": "Change plan — confirmation",
  "v9.abonnement.ecran.dialogue-resilier-abonnement": "Cancel the subscription",
  "v9.abonnement.ecran.organisation-abonnement": "Subscription, usage and billing",
  "v9.abonnement.ecran.organisation-abonnement-changement": "Subscription change tracking",
  "v9.abonnement.ecran.organisation-abonnement-historique": "Subscription history",
  "v9.abonnement.ecran.organisation-consommation": "Detailed organisation usage",
  "v9.abonnement.ecran.organisation-moyens-paiement": "Organisation payment methods",
  "v9.abonnement.ecran.plateforme-organisation-consommation": "Organisation record — usage",
  "v9.abonnement.ecran.plateforme-organisation-palier": "Organisation record — plan",
  "v9.abonnement.effet_le": "Takes effect on {{le}}.",
  "v9.abonnement.essai": "{{palier}} plan trial: {{jours}} day(s) left. Back to Free at the end unless you subscribe.",
  "v9.abonnement.etat.chargement": "Loading: {{quoi}}…",
  "v9.abonnement.etat.echec": "The operation failed.",
  "v9.abonnement.etat.erreur": "Could not load {{quoi}}.",
  "v9.abonnement.etat.refus": "Access denied.",
  "v9.abonnement.etat.vide": "Nothing to show.",
  "v9.abonnement.etat_changement.abandonne": "Abandoned with the provider.",
  "v9.abonnement.etat_changement.annule": "Cancelled.",
  "v9.abonnement.etat_changement.effectif": "Effective.",
  "v9.abonnement.etat_changement.en_attente_du_prestataire": "Waiting for the provider.",
  "v9.abonnement.etat_changement.paiement_refuse": "Payment declined.",
  "v9.abonnement.etat_changement.programme_a_l_echeance": "Scheduled at renewal.",
  "v9.abonnement.etat_changement.resultat_inconnu_verification_en_cours": "Unknown result: checking with the provider.",
  "v9.abonnement.exceptions.a_venir": "Exception requests come with package v9-p04.",
  "v9.abonnement.export.erreur": "Export failed.",
  "v9.abonnement.export.telecharge": "Statement downloaded.",
  "v9.abonnement.exporter": "Export statement (CSV)",
  "v9.abonnement.facture.aucune_au_palier_gratuit": "No invoice on the free plan.",
  "v9.abonnement.facture.estimee": "Next estimated invoice: {{montant}} on {{le}}.",
  "v9.abonnement.facture.vide": "No upcoming invoice.",
  "v9.abonnement.geste.annuler_changement": "Cancel the scheduled change",
  "v9.abonnement.geste.annuler_resiliation": "Withdraw the cancellation",
  "v9.abonnement.geste.changer": "Change plan",
  "v9.abonnement.geste.consommation": "Usage details",
  "v9.abonnement.geste.continuer_prestataire": "Continue with the provider",
  "v9.abonnement.geste.coordonnees": "Billing details",
  "v9.abonnement.geste.exception": "Request an exception",
  "v9.abonnement.geste.factures": "Invoices",
  "v9.abonnement.geste.historique": "Subscription history",
  "v9.abonnement.geste.moyens": "Payment methods",
  "v9.abonnement.geste.reessayer_paiement": "Retry payment",
  "v9.abonnement.geste.regler_impaye": "Pay the unpaid invoice",
  "v9.abonnement.geste.resilier": "Cancel subscription",
  "v9.abonnement.geste.souscrire_essai": "Subscribe to the trial plan",
  "v9.abonnement.geste.voir_changement": "View change",
  "v9.abonnement.geste.voir_exception": "View request",
  "v9.abonnement.historique.de": "From",
  "v9.abonnement.historique.le": "Date",
  "v9.abonnement.historique.origine": "Origin",
  "v9.abonnement.historique.suivi": "Tracking",
  "v9.abonnement.historique.titre": "Plan changes",
  "v9.abonnement.historique.vers": "To",
  "v9.abonnement.historique.vide": "No plan change.",
  "v9.abonnement.historique_changement": "Change history",
  "v9.abonnement.mobile.texte": "Instalment to pay by mobile money: {{montant}} on {{le}} (reminder on {{rappel}}).",
  "v9.abonnement.mobile.vide": "No mobile money instalment.",
  "v9.abonnement.mois": "Month",
  "v9.abonnement.mois_invalide": "Month expected as YYYY-MM.",
  "v9.abonnement.moyen_inutile": "No payment method is charged for this change.",
  "v9.abonnement.moyen_utilise": "Method used: {{moyen}}.",
  "v9.abonnement.moyens.ajouter": "Add a payment method",
  "v9.abonnement.moyens.confirmer_retrait": "Remove this method?",
  "v9.abonnement.moyens.defaut_ok": "Default method changed.",
  "v9.abonnement.moyens.definir_defaut": "Set as default",
  "v9.abonnement.moyens.expire_bientot": "Expires soon ({{le}})",
  "v9.abonnement.moyens.nature.carte": "Card",
  "v9.abonnement.moyens.nature.mobile_money": "Mobile money",
  "v9.abonnement.moyens.nature.prelevement": "Direct debit",
  "v9.abonnement.moyens.par_defaut": "Default",
  "v9.abonnement.moyens.reprendre_achat": "Resume purchase",
  "v9.abonnement.moyens.retire": "Method removed.",
  "v9.abonnement.moyens.retirer": "Remove",
  "v9.abonnement.moyens.revenir_devis": "Back to the quote",
  "v9.abonnement.moyens.revenir_facture": "Back to the invoice",
  "v9.abonnement.moyens.saisie_chez_le_prestataire": "Entry happens with the provider: DoIt only keeps a reference and a masked label.",
  "v9.abonnement.moyens.titre": "Payment methods",
  "v9.abonnement.moyens.vide": "No payment method.",
  "v9.abonnement.nature.descente": "Downgrade",
  "v9.abonnement.nature.migration": "Subscriber migration",
  "v9.abonnement.nature.montee": "Upgrade",
  "v9.abonnement.nature.periodicite": "Billing period change",
  "v9.abonnement.nature.resiliation": "Cancellation",
  "v9.abonnement.nature.souscription_devis": "Quote subscription",
  "v9.abonnement.nature.souscription_essai": "Trial plan subscription",
  "v9.abonnement.origine.exception_accordee": "Exception granted",
  "v9.abonnement.origine.force_par_la_plateforme": "Set by the platform",
  "v9.abonnement.origine.migration": "Subscriber migration",
  "v9.abonnement.origine.palier_par_defaut": "Default plan",
  "v9.abonnement.origine.par_le_proprietaire": "Chosen by the owner",
  "v9.abonnement.paiement.a_jour": "Payments up to date.",
  "v9.abonnement.paiement.acces_restreint": "Unpaid: restricted access.",
  "v9.abonnement.paiement.delai_de_grace": "Payment late: grace period running.",
  "v9.abonnement.paiement.descente_programmee": "Plan downgrade scheduled.",
  "v9.abonnement.paiement.resiliation_programmee": "Cancellation scheduled.",
  "v9.abonnement.paiement.suspendu_pour_impaye": "Suspended for non-payment.",
  "v9.abonnement.paiement.vide": "No payment state.",
  "v9.abonnement.palier.enterprise": "Enterprise",
  "v9.abonnement.palier.free": "Free",
  "v9.abonnement.palier.team": "Team",
  "v9.abonnement.periodicite.annuelle": "Yearly",
  "v9.abonnement.periodicite.mensuelle": "Monthly",
  "v9.abonnement.plateforme.changer_palier": "Change plan",
  "v9.abonnement.plateforme.choisir": "Choose…",
  "v9.abonnement.plateforme.confirmer": "Confirm the change",
  "v9.abonnement.plateforme.consequences": "Consequences",
  "v9.abonnement.plateforme.consequences_apres": "Consequences are described after the change.",
  "v9.abonnement.plateforme.depassement": "Usage above the new limits: {{liste}}.",
  "v9.abonnement.plateforme.facturation": "Billing effect: at next renewal.",
  "v9.abonnement.plateforme.force": "Plan changed.",
  "v9.abonnement.plateforme.libre_service_annule": "The open self-service change was cancelled.",
  "v9.abonnement.plateforme.motif": "Reason",
  "v9.abonnement.plateforme.nouveau_palier": "New plan",
  "v9.abonnement.plateforme.palier_actuel": "Current plan: {{palier}}.",
  "v9.abonnement.plateforme.palier_et_motif": "Choose a plan and enter a reason.",
  "v9.abonnement.plateforme.quotas_reduits": "Reduced quotas: {{liste}}.",
  "v9.abonnement.premier_debit": "First debit at the end of the trial: {{montant}} on {{le}}.",
  "v9.abonnement.premier_debit_aucun": "No debit before the end of the trial.",
  "v9.abonnement.prochaine_echeance": "next renewal on {{le}}",
  "v9.abonnement.projets.aucun_quota": "no quota set",
  "v9.abonnement.projets.non_visible": "not visible for this profile",
  "v9.abonnement.projets.titre": "Usage per project",
  "v9.abonnement.projets.vide": "No project in the organisation.",
  "v9.abonnement.prorata": "Prorated amount computed by the provider: {{montant}}.",
  "v9.abonnement.prorata_aucun": "Nothing to pay now.",
  "v9.abonnement.quoi.acces": "access during non-payment",
  "v9.abonnement.quoi.annonces": "price announcements",
  "v9.abonnement.quoi.apercu": "the change preview",
  "v9.abonnement.quoi.avis": "usage alerts",
  "v9.abonnement.quoi.changement": "the change",
  "v9.abonnement.quoi.composant": "the provider component",
  "v9.abonnement.quoi.credit": "the credit",
  "v9.abonnement.quoi.facture": "the next invoice",
  "v9.abonnement.quoi.historique": "the history",
  "v9.abonnement.quoi.mobile": "the mobile money instalment",
  "v9.abonnement.quoi.moyens": "payment methods",
  "v9.abonnement.quoi.paiement": "the payment state",
  "v9.abonnement.quoi.palier": "the plan",
  "v9.abonnement.quoi.projets": "per-project usage",
  "v9.abonnement.quoi.quotas": "the quotas",
  "v9.abonnement.quoi.releve": "the statement",
  "v9.abonnement.quotas.illimite": "unlimited",
  "v9.abonnement.quotas.limite_atteinte": "Limit reached",
  "v9.abonnement.quotas.nominal": "Normal",
  "v9.abonnement.quotas.proche_de_la_limite": "Close to the limit",
  "v9.abonnement.quotas.titre": "Quotas and usage",
  "v9.abonnement.quotas.vide": "No quota for this plan.",
  "v9.abonnement.raison.aucun_moyen": "Add a payment method first.",
  "v9.abonnement.raison.changement_deja_en_cours": "A change is already in progress: track or cancel it first.",
  "v9.abonnement.raison.deja_au_palier_gratuit": "You are already on the free plan.",
  "v9.abonnement.raison.deja_par_defaut": "Already the default method.",
  "v9.abonnement.raison.enregistrer_d_abord": "Save the method first.",
  "v9.abonnement.raison.exceptions_a_venir": "Exception requests come with package v9-p04.",
  "v9.abonnement.raison.factures_a_venir": "Invoices and billing details come with billing (package v9-p03).",
  "v9.abonnement.raison.hors_achat": "Only available from a plan change.",
  "v9.abonnement.raison.hors_devis": "Only available from a quote.",
  "v9.abonnement.raison.hors_facture": "Only available from an invoice.",
  "v9.abonnement.raison.non_annulable": "This change can no longer be cancelled.",
  "v9.abonnement.raison.prestataire_a_venir": "The real payment provider is not connected yet.",
  "v9.abonnement.raison.reauthentification_requise": "Confirm your identity to cancel.",
  "v9.abonnement.raison.resiliation_deja_programmee": "A cancellation is already scheduled.",
  "v9.abonnement.raison.saisie_incomplete": "Entry incomplete with the provider.",
  "v9.abonnement.raison.sans_changement": "Change without tracking (before self-service).",
  "v9.abonnement.raison.seul_moyen_requis": "Only payment method: your subscription requires a debit.",
  "v9.abonnement.raison.suppression_a_venir": "Organisation deletion comes with package v9-p05.",
  "v9.abonnement.rapprochement.ecart": "Discrepancy reported to the platform.",
  "v9.abonnement.rapprochement.non_rapproche": "Not reconciled.",
  "v9.abonnement.rapprochement.orphelin": "Event without known operation.",
  "v9.abonnement.rapprochement.rapproche": "Reconciled.",
  "v9.abonnement.recap.descente": "Downgrade to {{palier}} at renewal.",
  "v9.abonnement.recap.migration": "Migration to {{palier}}.",
  "v9.abonnement.recap.montee": "Upgrade to {{palier}} ({{periodicite}}).",
  "v9.abonnement.recap.periodicite": "Switch to {{periodicite}} billing for {{palier}}.",
  "v9.abonnement.recap.resiliation": "Cancellation.",
  "v9.abonnement.recap.souscription_devis": "Quote subscription.",
  "v9.abonnement.recap.souscription_essai": "Subscription to the trial plan {{palier}}.",
  "v9.abonnement.reessayer": "Retry",
  "v9.abonnement.reference": "Provider reference: {{reference}}",
  "v9.abonnement.reference_absente": "No provider reference.",
  "v9.abonnement.releve.jours": "Days",
  "v9.abonnement.releve.max": "Maximum",
  "v9.abonnement.releve.metrique": "Metric",
  "v9.abonnement.releve.quota": "Plan quota",
  "v9.abonnement.releve.titre": "Statement for {{mois}}",
  "v9.abonnement.releve.total": "Total",
  "v9.abonnement.releve.vide": "No usage this month.",
  "v9.abonnement.resilier.ce_qui_se_passe": "Cancellation takes effect at renewal: you return to the free plan; anything above it becomes read-only. You can withdraw it until then.",
  "v9.abonnement.resilier.confirmer": "Confirm cancellation",
  "v9.abonnement.resilier.depasse": "What exceeds the free plan",
  "v9.abonnement.resilier.garder": "Keep my subscription",
  "v9.abonnement.resilier.raison": "Cancellation reason",
  "v9.abonnement.resilier.raison_facultative": "(optional)",
  "v9.abonnement.resilier.raisons.autre": "Other",
  "v9.abonnement.resilier.raisons.autre_outil": "Another tool",
  "v9.abonnement.resilier.raisons.fonctionnalites": "Missing features",
  "v9.abonnement.resilier.raisons.projet_termine": "Project finished",
  "v9.abonnement.resilier.raisons.trop_cher": "Too expensive",
  "v9.abonnement.resilier.rien_ne_depasse": "Nothing exceeds the free plan.",
  "v9.abonnement.resilier.secret": "Password (identity confirmation)",
  "v9.abonnement.resilier.supprimer": "Delete the organisation instead",
  "v9.abonnement.retour": "Back to subscription",
  "v9.abonnement.section.facturation": "Billing",
  "v9.abonnement.section.palier": "Plan and usage"
}
